import i18next from 'i18next';
import { useCallback, useMemo } from 'react';
import { LanguageType } from '../../../../@types';
import { useAvailableLanguages } from '../../../../hooks/useAvailableLanguages';
import useLocalization from '../../../../hooks/useLocalization';
import { useLanguage } from '../../../../localization/LanguageInstanceProvider';

export const useNeobetLanguageSelect = () => {
  const { t } = useLocalization();
  const { setSelectedLanguage } = useLanguage();
  const availableLanguages = useAvailableLanguages();
  const label = t('language', 'Language');
  const currentLanguage = i18next.language as LanguageType | undefined;

  const value = useMemo(() => {
    const fallbackValue = availableLanguages[0]?.key ?? 'en';
    const selectedLanguage = currentLanguage ?? fallbackValue;

    return availableLanguages.some((language) => language.key === selectedLanguage) ? selectedLanguage : fallbackValue;
  }, [availableLanguages, currentLanguage]);

  const handleLanguageChange = useCallback(
    (language: LanguageType) => {
      setSelectedLanguage(language);
    },
    [setSelectedLanguage]
  );

  return {
    availableLanguages,
    handleLanguageChange,
    label,
    value,
  };
};
